export default {
  title: '積分商品',
  // 頂部按鈕
  addGift: '添加禮品',
  // 搜索欄
  giftInfo: '禮品信息',
  giftInfoPlaceholder: '請輸入關鍵詞搜索',
  category: '分類',
  publishStatus: '狀態',
  // 批量操作
  batchSetStock: '批量設置庫存',
  batchOnline: '批量上架',
  batchOffline: '批量下架',
  batchOnlineConfirm: '確定批量上架商品？',
  batchOfflineConfirm: '確定批量下架商品？',
  batchSetStockTitle: '批量設置庫存',
  batchSetStockPlaceholder: '請輸入庫存數量',
  batchSetStockTip: '將對所選 {count} 件禮品統一設置庫存',
  selectFirstTip: '請先勾選商品',
  // 表格列
  exchangePrice: '兌換價格',
  exchangedQty: '已兌換數量',
  stock: '庫存',
  status: '狀態',
  online: '已上架',
  offline: '已下架',
  createTime: '創建時間',
  // 操作
  edit: '編輯',
  delete: '刪除',
  deleteConfirm: '刪除後不可恢復，確定要刪除嗎？',
  // 行內庫存編輯
  editStock: '編輯庫存',
  stockRequired: '請輸入庫存數量',
  // 添加禮品 - 步驟
  stepSelectGift: '選擇禮品',
  stepGiftConfig: '禮品設置',
  addGiftTitle: '添加禮品',
  editGiftTitle: '編輯禮品',
  giftLibCategory: '禮品庫分類',
  pricePerYuan: '價格/元',
  giftType: '禮品類型',
  giftTypeAll: '全部',
  giftTypePhysical: '實物禮品',
  giftTypeVirtual: '虛擬禮品',
  stockCount: '庫存數',
  selectAction: '選擇',
  giftSnLabel: '編號',
  giftNo: '禮品編號',
  // 步驟 2 - 禮品設置
  selectedGift: '已選禮品',
  marketPrice: '市場價格',
  exchangePriceLabel: '可兌換價格',
  pointsPay: '積分支付',
  exchangeQty: '可兌換數量',
  specInfo: '規格信息',
  specStock: '規格庫存',
  exchangePriceCol: '兌換價格',
  pointsUnit: '積分',
  inputPlaceholder: '請輸入',
  virtualExchange: '虛擬兌換量',
  virtualExchangePlaceholder: '請輸入虛擬兌換量',
  listSort: '列表排序',
  listSortPlaceholder: '請輸入',
  publish: '立即上架',
  // 校驗
  categoryRequired: '請選擇分類',
  exchangePriceRequired: '請選擇可兌換價格',
  specStockRequired: '請填寫規格庫存',
  specPriceRequired: '請填寫兌換價格',
};
